import { render, staticRenderFns } from "./Map2.vue?vue&type=template&id=c06e4d6a&scoped=true"
import script from "./Map2.vue?vue&type=script&lang=js"
export * from "./Map2.vue?vue&type=script&lang=js"
import style0 from "./Map2.vue?vue&type=style&index=0&id=c06e4d6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06e4d6a",
  null
  
)

export default component.exports